__turbopack_context__.v({
  "form": "UserDetailsForm-module__dhJC-q__form",
});
